const filterOutEmptyRows = (originalRows) =>
  originalRows.filter((row) => row.find((x) => x.length > 0))

export default filterOutEmptyRows
